import React from 'react'
import {Flex} from '@chakra-ui/react'
import {WARRANTY_STEPS, useWarrantyContext} from '../util/warranty-context'
import StepIndicator from './step-indicator'
import ProductSelection from './product-selection'
import ProductDetails from './product-details'
import PointOfPurchase from './point-of-purchase'
import CustomerDetails from './customer-details'

const WarrantyWizard = () => {
    const {step, mode, steps} = useWarrantyContext()

    return (
        <Flex flexDirection="column" gap={8}>
            <StepIndicator step={step} steps={steps} />

            {step === WARRANTY_STEPS[mode].PRODUCT_SELECTION && <ProductSelection />}
            {step === WARRANTY_STEPS[mode].PRODUCT_DETAILS && <ProductDetails />}
            {step === WARRANTY_STEPS[mode].POINT_OF_PURCHASE && <PointOfPurchase />}
            {step === WARRANTY_STEPS[mode].CUSTOMER_DATA && <CustomerDetails />}
        </Flex>
    )
}

export default WarrantyWizard
